module.exports = __webpack_public_path__ + "img/Grundt_Zach.c1254fc9.png";